import { type FunctionComponent } from 'react';
import { useProjectsTour } from '../../../../hooks/projects-tour/projects-tour.hooks';
import { StyledButton } from '../../../buttons';
import RouteIcon from '../../../svgs/untitled-ui/route.svg';

type ProjectsTourButtonProps = {
	buttonText?: string;
	buttonStyle?: 'PRIMARY' | 'SECONDARY';
	size?: 'SMALL' | 'DEFAULT';
	showIcon?: boolean;
};

export const ProjectsTourButton: FunctionComponent<ProjectsTourButtonProps> = ({
	buttonText = 'Take a Tour',
	buttonStyle = 'SECONDARY',
	size = 'DEFAULT',
	showIcon
}) => {
	const { startTour } = useProjectsTour();

	return (
		<StyledButton ariaLabel={buttonText} buttonStyle={buttonStyle} size={size} onClick={startTour}>
			<div className="flex items-center justify-center">
				{showIcon && <RouteIcon className="pr2" />}
				{buttonText}
			</div>
		</StyledButton>
	);
};
